import React, { FunctionComponent } from "react";
import { Stack, Box } from "@chakra-ui/react";

import { SiteConfig_siteConfig_commandConf } from "graphql/generated";

import { useLiveMeasurements } from "scenes/site/hooks";
import IframeChart from "components/iframe-chart";
import ExternalCommandStatsTable from "./ExternalCommandStatsTable";
import RtuCommandStatsTable from "./RtuCommandStatsTable";


interface IProps {
  siteId: string;
  commandConf: SiteConfig_siteConfig_commandConf;
}


const Command: FunctionComponent<IProps> = ({ siteId, commandConf }) => {
  const { data } = useLiveMeasurements(siteId, "commands");

  return (
    <Stack direction="row" spacing={8}>
      <Box flex={1}>
        <IframeChart chart={commandConf.chartA} title="aggregator commands" />
        <ExternalCommandStatsTable data={data["external_command"] || {}} uiVersion={commandConf.uiVersion} />
      </Box>

      <Box flex={1}>
        <IframeChart chart={commandConf.chartB} title="distributor commands" />
        <RtuCommandStatsTable data={data["rtu_command"] || {}} uiVersion={commandConf.uiVersion} />
      </Box>
    </Stack>
  );
};

export default Command;
